"use client";

import { c as _c } from "react/compiler-runtime";
import CreateDropMetadataItems from "@/components/drops/create/utils/metadata/CreateDropMetadataItems";
import { DropMetadata } from "@/entities/IDrop";
import { useRef, useState } from "react";
export default function CreateDropFullDesktopMetadata(t0) {
  const $ = _c(22);
  const {
    metadata,
    onMetadataEdit,
    onMetadataRemove
  } = t0;
  const [key, setKey] = useState(null);
  const [value, setValue] = useState(null);
  const metadataKeyRef = useRef(null);
  let t1;
  if ($[0] !== key || $[1] !== onMetadataEdit || $[2] !== value) {
    t1 = e => {
      e.preventDefault();
      if (key && value) {
        onMetadataEdit({
          data_key: key,
          data_value: value
        });
        setKey(null);
        setValue(null);
        metadataKeyRef.current?.focus();
      }
    };
    $[0] = key;
    $[1] = onMetadataEdit;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label htmlFor="metadata-form" className="tw-block tw-font-medium tw-text-iron-300 tw-text-sm">Metadata</label>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = key ?? "";
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_0 => setKey(e_0.target.value);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="tw-w-full"><input ref={metadataKeyRef} type="text" placeholder="Category" value={t3} onChange={t4} maxLength={100} className="tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-2.5 tw-pr-3 tw-bg-iron-800 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-bg-iron-900 focus:tw-ring-1 focus:tw-ring-inset hover:tw-ring-iron-700 focus:tw-ring-primary-400 tw-text-md tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = value ?? "";
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_1 => setValue(e_1.target.value);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6) {
    t8 = <div className="tw-w-full"><input type="text" placeholder="Value" value={t6} onChange={t7} maxLength={500} className="tw-form-input tw-appearance-none tw-block tw-w-full tw-rounded-lg tw-border-0 tw-py-2.5 tw-pr-3 tw-bg-iron-800 tw-text-iron-50 tw-font-normal tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-800 placeholder:tw-text-iron-400 focus:tw-outline-none focus:tw-bg-iron-900 focus:tw-ring-1 focus:tw-ring-inset hover:tw-ring-iron-700 focus:tw-ring-primary-400 tw-text-md tw-leading-6 tw-transition tw-duration-300 tw-ease-out" /></div>;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <button type="submit" aria-label="Add metadata" title="Add metadata" className="tw-inline-flex tw-items-center tw-rounded-lg tw-bg-iron-800 tw-px-2.5 tw-py-2.5 tw-text-iron-300 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-border-0 tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-bg-iron-700 hover:tw-text-iron-200 focus:tw-z-10 tw-transition tw-duration-300 tw-ease-out"><svg className="tw-w-5 tw-h-5 tw-flex" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== onSubmit || $[13] !== t5 || $[14] !== t8) {
    t10 = <form id="metadata-form" onSubmit={onSubmit} className="tw-mt-1.5 tw-flex tw-items-center tw-gap-x-3 tw-w-full">{t5}{t8}{t9}</form>;
    $[12] = onSubmit;
    $[13] = t5;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== metadata || $[17] !== onMetadataRemove) {
    t11 = <CreateDropMetadataItems items={metadata} onMetadataRemove={onMetadataRemove} />;
    $[16] = metadata;
    $[17] = onMetadataRemove;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div>{t2}{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}